if (!customElements.get('wonder-inventor-player')) {
    customElements.define('wonder-inventor-player', class extends HTMLElement {
      connectedCallback() {
        if (this.initialized) return;
        const video = this.querySelector('video');
        const button = this.querySelector('button');
        if (!video || !button) return;
        this.initialized = true;
        video.controls = false;
        button.hidden = false;
        button.addEventListener('click', () => {
          button.hidden = true;
          video.controls = true;
          video.play().then(() => video.focus()).catch(() => { button.hidden = false; });
        });
        video.addEventListener('play', () => { button.hidden = true; video.controls = true; });
        video.addEventListener('ended', () => { button.hidden = false; video.controls = false; });
      }
    });
  }
